import styles from './DebugHud.module.scss';
import { DnaHubDebugSnapshot } from './useFrameSequence';

interface DebugHudProps {
  snapshot: DnaHubDebugSnapshot;
}

export const DebugHud = ({ snapshot }: DebugHudProps): JSX.Element => (
  <div className={styles.hud}>
    <div>
      frames {snapshot.framesLoaded}/{snapshot.totalFrames}
    </div>
    <div>decode {snapshot.decodeTimeMs.toFixed(0)}ms</div>
    <div>frame #{snapshot.frameIndex}</div>
    <div>{snapshot.fps} fps</div>
  </div>
);
